import { render, staticRenderFns } from "./RunnerInfoColumn.vue?vue&type=template&id=05621f65"
import script from "./RunnerInfoColumn.vue?vue&type=script&lang=js"
export * from "./RunnerInfoColumn.vue?vue&type=script&lang=js"
import style0 from "./RunnerInfoColumn.vue?vue&type=style&index=0&id=05621f65&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports